import { PlanSummary } from './plan-summary.model';

export class PlanRevenue {
  readonly planId: string;
  readonly planName: string;
  readonly marketLabel: string;
  readonly currency: string | null;
  readonly subscriberCount: number;
  readonly scannedCount: number;
  readonly monthlyRevenue: number;
  readonly isPartial: boolean;

  constructor(plan: PlanSummary, scannedCount: number, monthlyRevenue: number, total: number) {
    this.planId = plan.id;
    this.planName = plan.displayName;
    this.marketLabel = plan.marketLabel;
    this.currency = plan.currency;
    this.subscriberCount = total;
    this.scannedCount = scannedCount;
    this.monthlyRevenue = monthlyRevenue;
    this.isPartial = scannedCount < total;
  }
}
